import axios from 'axios'

export default axios.create({
    baseURL: 'https://api.somethingred.nl/v1/production',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + window.localStorage.getItem('api_token'),
    }
})